export * from './ArrowShapeTriangleAUpIcon';
export * from './ArrowShapeTriangleAUpIcon16Light';
export * from './ArrowShapeTriangleAUpIcon16Regular';
export * from './ArrowShapeTriangleAUpIcon16Solid';
export * from './ArrowShapeTriangleAUpIcon20Light';
export * from './ArrowShapeTriangleAUpIcon20Regular';
export * from './ArrowShapeTriangleAUpIcon20Solid';
export * from './ArrowShapeTriangleAUpIcon24Regular';
export * from './ArrowShapeTriangleAUpIcon24Solid';
export * from './ArrowShapeTriangleAUpIcon32Regular';
export * from './ArrowShapeTriangleAUpIcon64Regular';
